import React from 'react';
import PlayBadge, { PLAY_BADGE_SIZE } from '../../../ui-components/PlayBadge/PlayBadge';
import Link from 'next/link';
import {
    SearchSuggestionEpisodeText,
    SearchSuggestionLink,
    SearchSuggestionLinkText,
    SearchSuggestionThumbnail,
    ThumbNailImage,
    SearchSuggestionTextWrapper,
    SearchSuggestionLinkByline,
} from './AutoCompleteResult.styles';
import { stripEms, getUrl, value } from './helpers';
import { createImageProxyUrl } from 'app/utils/svtimage';
import syntolkat from 'public/static/images/accessibility/syntolkat_100x56.png';
import teckensprak from 'public/static/images/accessibility/teckentolkat_100x56.png';
import tydligaretal from 'public/static/images/accessibility/tydligaretal_100x56.png';
import upplasttext from 'public/static/images/accessibility/upplasttext_100x56.png';
import { fontWeightBold } from '../../../ui-components/design-tokens';
import { SIZE } from '../../../ui-components/typography/PlayText/PlayText';

const accessibilityIds = ['teckensprak', 'syntolkat', 'tydligare-tal', 'upplast-undertext'];

const a11yThumbnail = (id) => {
    switch (id) {
        case 'syntolkat':
            return syntolkat;
        case 'teckensprak':
            return teckensprak;
        case 'upplast-undertext':
            return upplasttext;
        default:
            return tydligaretal;
    }
};

const getThumbnail = (teaser = {}) => {
    if (teaser.images) {
        return createImageProxyUrl(
            teaser.images.wide.id,
            teaser.images.wide.changed,
            'wide',
            140,
            'quality=90'
        );
    }

    if (accessibilityIds.includes(teaser.id)) {
        return a11yThumbnail(teaser.id);
    }

    return createImageProxyUrl(teaser.image.id, teaser.image.changed, 'wide', 140, 'quality=90');
};

const getThumbnailAlt = (teaser = {}) => {
    if (teaser.images) {
        return teaser.images.wide.description;
    }

    return teaser.heading ? `${stripEms(teaser.heading)} bild` : undefined;
};

const getHeading = (teaser = {}) => {
    return teaser.heading ? stripEms(teaser.heading) : undefined;
};

const getSubheading = (teaser = {}) => {
    return teaser.subHeading ? stripEms(teaser.subHeading) : undefined;
};

const PopOverLink = ({ item, suggestionClick }) => {
    const teaser = item.teaser || item.categoryTeaser || {};
    const thumbnail = getThumbnail(teaser);
    const thumbnailAltText = getThumbnailAlt(teaser);

    return (
        <Link href={getUrl(item)} passHref>
            <SearchSuggestionLink
                data-rt-spec="auto-complete-link"
                onMouseDown={() => {
                    suggestionClick(value(item));
                }}
            >
                {thumbnail && (
                    <SearchSuggestionThumbnail>
                        {teaser.badge && (
                            <PlayBadge
                                text={teaser.badge.text}
                                theme={teaser.badge.type}
                                accessibilityText={teaser.badge.altText}
                                overlay
                                size={PLAY_BADGE_SIZE.SMALL}
                            />
                        )}
                        <ThumbNailImage key={thumbnail} src={thumbnail} alt={thumbnailAltText} />
                    </SearchSuggestionThumbnail>
                )}
                <SearchSuggestionTextWrapper>
                    <SearchSuggestionLinkByline as="span">{teaser?.byline}</SearchSuggestionLinkByline>
                    <SearchSuggestionLinkText className="linkText" weight={fontWeightBold} size={SIZE.LARGE}>
                        {getHeading(teaser)}
                    </SearchSuggestionLinkText>
                    <SearchSuggestionEpisodeText>{getSubheading(teaser)}</SearchSuggestionEpisodeText>
                </SearchSuggestionTextWrapper>
            </SearchSuggestionLink>
        </Link>
    );
};

export default PopOverLink;
